// src/utils/Helper.js

import DateTime from "./DateTime";

class Helper {
  static GenerateHashId = async (input) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return [...new Uint8Array(hashBuffer)]
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("")
      .slice(0, 32);
  };

  static DownloadFile(url, FileName) {
    const a = document.createElement("a");
    a.href = url;
    a.download =
      FileName || (typeof url == "object"
        ? url.href.split("/").pop()
        : url.split("/").pop());
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      if (a.parentNode) a.parentNode.removeChild(a);
    }, 100);
  }

  // Returns true if the text's first strong directional character is RTL.
  // Covers Arabic, Hebrew, Persian, Urdu, Syriac, N'Ko, and all related scripts.
  static IsRTL(text = "") {
    if (!text) return false;
    const RTL = /[\u0590-\u05FF\u0600-\u06FF\u0700-\u077F\u07C0-\u07FF\u0800-\u083F\u08A0-\u08FF\uFB1D-\uFB4F\uFB50-\uFDFF\uFE70-\uFEFF]/;
    const LTR = /[A-Za-z\u00C0-\u024F\u0370-\u03FF\u0400-\u04FF]/;
    for (const char of text) {
      if (RTL.test(char)) return true;
      if (LTR.test(char)) return false;
    }
    return false;
  }
  // Kept for backward compatibility \u2014 delegates to IsRTL.
  static IsArabic(text = "") {
    return Helper.IsRTL(text);
  }

  static HandleChatDate = DateTime.HandleChatDate;

  static OnNotifyVoice(Type = "Message") {
    const AudioMap = {
      Message: "Message-Audio",
      Notification: "Notification-Audio",
    };
    const AudioId = AudioMap[Type] || "Notification-Audio";
    const AudioElement = document.getElementById(AudioId);
    if (AudioElement) {
      AudioElement.muted = false;
      AudioElement.volume = 1.0;
      AudioElement.currentTime = 0;
      AudioElement.play().catch((err) => {
        console.warn("Failed to play audio:", err);
      });
    }
  }

  static FormatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }


  // ========== AUTHENTICATION HELPER FUNCTIONS ==========

  // دالة فك التوكن والتحقق من صلاحيته
  static DecodeJwt(token) {
    try {
      const base64Payload = token.split(".")[1];
      const payload = atob(base64Payload.replace(/-/g, "+").replace(/_/g, "/"));
      return JSON.parse(payload);
    } catch {
      return null;
    }
  }
 // التحقق إذا كان التوكن منتهي أو على وشك الانتهاء
  static IsTokenExpired(token, thresholdSeconds = 30) {
    const decoded = this.DecodeJwt(token);
    if (!decoded?.exp) return true;
    
    const now = Math.floor(Date.now() / 1000);
    return decoded.exp - now < thresholdSeconds;
  }

  // التحقق من الوقت المتبقي للتوكن بالثواني
  static GetTokenTimeLeft(token) {
    const decoded = this.DecodeJwt(token);
    if (!decoded?.exp) return 0;
    
    const now = Math.floor(Date.now() / 1000);
    return Math.max(0, decoded.exp - now);
  }


  // تخزين بيانات المستخدم
  static SetStorage(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error('Error saving to storage:', error);
      return false;
    }
  }


   // استرجاع بيانات المستخدم
  static GetStorage(key) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error reading from storage:', error);
      return null;
    }
  }

    // مسح بيانات التخزين
  static ClearStorage() {
    try {
      localStorage.clear();
      return true;
    } catch (error) {
      console.error('Error clearing storage:', error);
      return false;
    }
  }
}

export default Helper;